export const TesEmployeeDetailsGetters = {
  CurrentTesEmployee: 'getCurrentTesEmployee',
  ValidationError: 'getValidationErrorKey',
  TesEmployeeValidationErrors: 'getTesEmployeeValidationErrors'
};

export const TesEmployeeDetailsMutations = {
  ResetTesEmployeeState: 'resetTesEmployeeState',
  SetLoading: 'setLoading',
  RetrieveTesEmployeeSuccess: 'retrieveTesEmployeeSuccess',
  SetTesEmployeeValidationErrors: 'setTesEmployeeValidationError'
};

export const TesEmployeeDetailsActions = {
  ResetCurrentTesEmployee: 'resetCurrentTesEmployee',
  RetrieveTesEmployee: 'retrieveTesEmployee',
  SaveTesEmployee: 'saveTesEmployee',
  UpdateTesEmployeeValidationErrors: 'updateTesEmployeesValidationErrors'
};
